module.exports = __webpack_public_path__ + "static/media/side-layer-benefit.ef792922.png";